export default __webpack_public_path__ + "static/media/6.cb55c5d1.jpg";